import HowToUse from './HowToUse'

export default HowToUse
